import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    stakeholders: [],
    currentStakeholder: null,
    structureName: null,
    currentClassification: null,
    totalPointObj: {},
    addTouristToDocLoading: false,
    countries: []
}

const stakeholderSlice = createSlice({
    name: 'stakeholder',
    initialState,
    reducers: {
        setTotalPointObj(state, action) {
            state.totalPointObj = action.payload;
        },
        setCountries(state, action) {
            state.countries = action.payload;
        },
        setTouristToDocLoading(state, action) {
            state.addTouristToDocLoading = action.payload;
        },
        setStakeholders(state, action) {
            state.stakeholders = action.payload;
        },
        setCurrentStakeholder(state, action) {
            state.currentStakeholder = action.payload;
        },
        setStructureName(state, action) {
            state.structureName = action.payload;
        },
        setCurrentClassification(state, action) {
            state.currentClassification = action.payload;
        },
        removeAll(state) {
            state.currentStakeholder = null;
            state.stakeholders = [];
            state.structureName = null;
            state.currentClassification = null;
            state.activeRequest = false;
        },
    }
});

export const { setStakeholders, setCurrentStakeholder, setCountries, setStructureName, setCurrentClassification, removeAll, setTotalPointObj, setTouristToDocLoading } = stakeholderSlice.actions

export default stakeholderSlice.reducer;
